import { combineReducers } from "redux";
import { dynamicInvoicesPageReducer as pageReducer } from "./dynamic-invoice-page-store";
import { dynamicInvoiceDialogControllerReducer } from "./components/dynamic-invoice-dialog/dynamic-invoice-dialog-controller-store";
import { dynamicInvoiceDialogReducer } from "./components/dynamic-invoice-dialog/dynamic-invoice-dialog-store";
import { previewDialogReducer } from "./components/preview-dialog/preview-dialog-store";
import { mainInformationReducer } from "./components/dynamic-invoice-dialog/components/main-information/main-information-store";
import { matterLedgerEntriesReducer } from "./components/dynamic-invoice-dialog/components/matter-ledger-entries/matter-ledger-entries-store";
import { timeTrackEntriesReducer } from "./components/dynamic-invoice-dialog/components/time-track-entries/time-track-entries-store";
export const dynamicInvoicesPageReducer = combineReducers({
    page: pageReducer,
    previewDialog: previewDialogReducer,
    dynamicInvoiceDialogController: dynamicInvoiceDialogControllerReducer,
    dynamicInvoiceDialog: dynamicInvoiceDialogReducer,
    matterLedgerEntries: matterLedgerEntriesReducer,
    timeTrackLedgerEntries: timeTrackEntriesReducer,
    mainInformation: mainInformationReducer
});
